import React from 'react';
import {
  Input,
  Text,
  useColorModeValue,
  HStack,
} from '@chakra-ui/react';
import { useSearch } from '../../../contexts/SearchContext';

export function DateFilter(props) {
  const inputBg = useColorModeValue('secondaryGray.300', 'navy.900');
  const inputText = useColorModeValue('gray.700', 'gray.100');

  const { draftStartDate, draftEndDate, updateDraftStartDate, updateDraftEndDate } =
    useSearch();

  return (
    <HStack spacing={4} align="center" {...props}>
      <HStack spacing={2}>
        <Text fontSize="sm" whiteSpace="nowrap">
          Desde:
        </Text>
        <Input
          type="date"
          fontSize="sm"
          bg={inputBg}
          color={inputText}
          borderRadius="md"
          value={draftStartDate}
          onChange={(e) => updateDraftStartDate(e.target.value)}
          w="160px"
        />
      </HStack>

      <HStack spacing={2}>
        <Text fontSize="sm" whiteSpace="nowrap">
          Hasta:
        </Text>
        <Input
          type="date"
          fontSize="sm"
          bg={inputBg}
          color={inputText}
          borderRadius="md"
          value={draftEndDate}
          onChange={(e) => updateDraftEndDate(e.target.value)}
          w="160px"
        />
      </HStack>
    </HStack>
  );
}
